import React from "react";
import TipsView from './TipsView';

export default class CountdownTipsView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            countdownTimer: ''
        };
        this.countdownInterval = null;
    }

    componentDidMount() {
        this.startCountdown(this.props.DepositTimer);
    }

    startCountdown(timerString) {
        const [minutes, seconds] = timerString.split(':').map(Number);
        let totalSeconds = minutes * 60 + seconds;
        
        this.countdownInterval = setInterval(() => {
            if (totalSeconds > 0) {
                totalSeconds--;
                const mm = Math.floor(totalSeconds / 60);
                const ss = totalSeconds % 60;
                const countdownTimer = `${mm.toString().padStart(2, '0')}:${ss.toString().padStart(2, '0')}`;
                this.setState({ countdownTimer });
            } else {
                clearInterval(this.countdownInterval);
                this.props.onCountdownFinish();
            }
        }, 1000);
    }
    
    componentWillUnmount() {
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
        }
    }
    render() {
        const { countdownTimer } = this.state
        return (
            <TipsView msg={`โปรดทำรายการฝากของคุณให้เสร็จสิ้นภายใน ${countdownTimer} นาทีมิฉะนั้นระบบจะทำการยกเลิกโดยอัตโนมัติ`} />
        )
    }
}

